import { dashboardApi } from '@/store/api/base/api.base';
import { writeDayNote } from '@/store/api/calendar/calendar.daynote.cache';
import type { TypeDayNote } from '@/types/calendar/types.calendar';

export const DAY_NOTE_MAX = 4000;

export const dayNoteApi = dashboardApi.injectEndpoints({
    endpoints: (build) => ({
        readDayNote: build.query<TypeDayNote, string>({
            query: (date) => ({ url: `/daynotes/${date}` }),
            providesTags: (_result, _error, date) => [{ type: 'DayNote', id: date }],
        }),

        saveDayNote: build.mutation<TypeDayNote, { date: string; body: string }>({
            query: ({ date, body }) => ({ url: `/daynotes/${date}`, method: 'patch', data: { body } }),
            onQueryStarted: async ({ date, body }, { dispatch, queryFulfilled }) => {
                const patch = dispatch(dayNoteApi.util.updateQueryData('readDayNote', date, (draft) => { draft.body = body; }));
                try {
                    const { data } = await queryFulfilled;
                    writeDayNote(dispatch, data);
                } catch {
                    patch.undo();
                }
            },
        }),
    }),
});

export const { useReadDayNoteQuery, useSaveDayNoteMutation } = dayNoteApi;

export default dayNoteApi;
